export default "__VITE_ASSET__JsUNow01__"